<template>
  <div>
    <CustomDialog ref='profile' :element='dialog.element.eleProfile' :styles='dialog.styles' :messages='dialog.messages.profile'>
      <template v-slot:dialog-content>
        <div>
          <ejs-grid ref='grid' :dataSource="data" height='100%' :pageSettings="page" :rowDeselected='getCheckedCount' :rowSelected='getCheckedCount' :allowReordering='true' :allowResizing='true'>
            <e-columns>
              <e-column field='profileId' :headerText='$t("LteUser.pdnProfileId")' width='8%' clipMode='EllipsisWithTooltip' textAlign='Center'></e-column>
              <e-column field='apnname' :headerText='$t("LteUser.pdnApnName")' width="8%" clipMode='EllipsisWithTooltip' textAlign='Center' ></e-column>
              <e-column field='pdntype' :headerText='$t("LteUser.pdnType")'  width="8%" clipMode='EllipsisWithTooltip' textAlign='Center' ></e-column>
            </e-columns>
          </ejs-grid>
          <ejs-pager ref='pager' @click='qryList(ne)' :pageSize='page.pageSize' :currentPage='page.pageNo' :totalRecordsCount='page.totalCount' ></ejs-pager>
        </div>
      </template>
    </CustomDialog>
  </div>
</template>
<script>

import CustomDialog from '../../../../common/CustomDialog';
import ajaxUrl from "../../../data/ajaxUrl";

export default {
  name: "PdnProfileList",
  components: {
    CustomDialog,
  },
  props: [
    'getCheckedDatas',
    'ne'
  ],
  methods: {
    qryList(ne, profileId) {
      this.page.pageNo = this.$refs.pager.ej2Instances.currentPage;
      const params = {
        vo: {
          "0": {
            profileId: profileId,
            neid: ne.neid,
          }
        },
        info: {
          operation: "qryProfileByID",
          neid: ne.neid,
        },
        page: {
          pageNo: this.page.pageNo,
          pageSize: this.page.pageSize,
        },
      };
      this.$axios.post(ajaxUrl.qryProfileByID, params).then((response) => {
        if (!response) {
          console.log("qryProfileByID response error");
          return;
        }
        if (!response.data) {
          console.log("qryProfileByID response.data error");
          return;
        }
        if (!response.data.resultVal) {
          console.log("qryProfileByID response.data.resultVal error");
          return;
        }
        const res = JSON.parse(response.data.resultVal);
        if (res.result) {
          this.data = res.result.map(item => {
            return {
              ...item,
              "pdntype": this.descPdnType[item.pdntype],
            }
          });
        }
        this.page.pageCount = res.totalPages;
        this.page.totalCount = res.totalCount;
        this.page.pageCount = Math.ceil(res.totalCount / this.page.pageSize);
      });
    },
    show() {
      this.$refs.profile.show();
    },
    save() {
      const checkedKeys = this.getCheckedKeys();
      this.getCheckedDatas(checkedKeys);
      if(checkedKeys) {
        if(this.getCheckedDatas) {
          this.getCheckedDatas(checkedKeys);
        }
        this.close();
        return;
      }
    },
    close() {
      this.$refs.profile.clear();
      this.$refs.profile.close();
    },
    getCheckedRecords() {
      const selectedRecords = this.$refs.grid.getSelectedRecords();
      return selectedRecords;
    },
    getCheckedKeys() {
      // x-> false: 不支持多选   true: 支持多选
      const profileId = [];
      const checkedData = this.getCheckedRecords();
      console.log('checkedData',checkedData)
      for (let i = 0; i < checkedData.length; i++) {
        profileId.push({
          profileId: checkedData[i].profileId,
          pdnType: this.getKey(this.descPdnType, checkedData[i].pdntype),
        });
      }
      return profileId.length === 0 ? null : profileId;
    },
    getCheckedCount() {
      const selectedRecords = this.$refs.grid.getSelectedRecords();
      this.checkedCount = selectedRecords.length;
    },
    getKey(obj, value) {
      for(let key in obj){
        if (value === obj[key]) {
          return Number(key);
        }
      }
    },
  },
  data() {
    return {
      data: {},
      checkedCount: 0,
      page: {
        pageNo: 1,
        pageSize: 100,
        totalCount: 0,
        pageCount: 0,
      },
      dialog: {
        styles: {
          width: '50%',
          height: '60%',
          visible: false,
          model: true,
          zIndex: 1001
        },
        element: {
          eleProfile: {
            target: this.$refs.Profile,
            refName: 'eleProfile',
            buttonGroup: [
              { click: this.close, buttonModel: { content: this.$t("LteUser.cancel") } },
              { click: this.save, buttonModel: { content: this.$t("LteUser.confirm"), isPrimary: true } }
            ],
            title: this.$t("LteUser.pdnProfileList"),
            isClose: true,
          },
        },
        messages: {
          profile: {
            title: this.$t("LteUser.pdnProfileList"),
          },
        },
      },
      descPdnType: {
        0: this.$t("PDN.ipv4"),
        1: this.$t("PDN.ipv6"),
        2: this.$t("PDN.doubleStack"),
      },
    };
  },
};
</script>
